<template>
    <Select v-model="settingsStore.country">
    <SelectTrigger class="w-[180px] bg-white">
      <SelectValue placeholder="Страна" />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        <SelectLabel>Страны</SelectLabel>
        <SelectItem v-for="country in dictionaryStore.dictionary.countries" :key="country.code" :value="country.code">
          {{ country.name }}
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useSettingsStore } from '@/store/settings'
import { useDictionaryStore } from '@/store/dictionary'
const emit = defineEmits(['update:country']);
const settingsStore = useSettingsStore();
const dictionaryStore = useDictionaryStore();


watch(
  () => settingsStore.country,
  (newVal) => {
    if (newVal) {
      localStorage.setItem('country', newVal);
      const currentCountryObject = dictionaryStore.dictionary.countries?.find((country) => country.code === newVal);
      if (currentCountryObject) {
        settingsStore.currency = dictionaryStore.dictionary?.currencies?.find(currency => currency.id === currentCountryObject.currency_id);
      }

      emit('update:country', newVal);
    }
  }
);

</script>
